
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 6853 973","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"486.488","cy":"486.488","r":"486.488","fill":"#d00130"}}),_c('circle',{attrs:{"cx":"1662.45","cy":"486.488","r":"486.488","fill":"#0b0c0f"}}),_c('circle',{attrs:{"cx":"2838.41","cy":"486.488","r":"486.488","fill":"#0b0c0f"}}),_c('circle',{attrs:{"cx":"4014.38","cy":"486.488","r":"486.488","fill":"#0b0c0f"}}),_c('circle',{attrs:{"cx":"5190.34","cy":"486.488","r":"486.488","fill":"#0b0c0f"}}),_c('circle',{attrs:{"cx":"6366.3","cy":"486.488","r":"486.488","fill":"#0b0c0f"}}),_c('path',{attrs:{"d":"M486.488 759.488c-45.5 0-84.875-11.75-118.125-35.25s-58.75-56.25-76.5-98.25-26.625-90-26.625-144c0-53.5 9.375-100.5 28.125-141s44.875-71.875 78.375-94.125 71.75-33.375 114.75-33.375c44 0 82.75 11.125 116.25 33.375s59.375 53.625 77.625 94.125 27.375 87.5 27.375 141c0 54-8.75 102-26.25 144s-43 74.75-76.5 98.25-73 35.25-118.5 35.25zm0-64.5c46.5 0 82.375-18.5 107.625-55.5s37.875-89.5 37.875-157.5c0-67-12.875-117.75-38.625-152.25s-61.375-51.75-106.875-51.75c-43.5 0-78.625 17.5-105.375 52.5s-40.125 85.5-40.125 151.5c0 68 12.625 120.5 37.875 157.5s61.125 55.5 107.625 55.5z","fill":"#fff","fill-rule":"nonzero"}})])
          )
        }
      }
    